/* Add to cart without leaving the page: any button with data-tg-add="variantId[,variantId]".
   Used by "Add both to cart" (snippets/tg-find-setup.liquid), the card + button (snippets/tg-card.liquid) and cart
   permalinks inside article bodies (the setups article).
   Adds every line in one request, refreshes Horizon's cart drawer and count, then opens the drawer.
   Optional data-tg-done / data-tg-fail text goes into the nearest [data-tg-msg]. */
(function () {
  if (window.tgAddJs) return;
  window.tgAddJs = true;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* Cart permalinks in article bodies ("Add the whole setup": /cart/id:qty,id:qty) add to the cart instead of
     replacing it, then open the drawer. If the add fails, the link works as a plain permalink. */
  var PERMA = /\/cart\/(\d+:\d+(?:,\d+:\d+)*)/;

  /* v27 (CRO spec tasks/cro/teams-sell-and-pack-atc-spec-2026-10-29.md §C): a button with data-tg-ev="<event>" sends one
     GA4 + Clarity event after the cart add returns OK, never on the click, so failed adds don't count.
     data-tg-ev-k / data-tg-ev-v add one param (guide=<handle>, team=<handle>); Clarity gets it as "<event stem>_<k>". */
  function track(btn, added, evx) {
    var ev = btn.getAttribute('data-tg-ev');
    if (!ev) return;
    var cents = 0, handles = [];
    added.forEach(function (it) { cents += it.final_line_price || 0; if (handles.indexOf(it.handle) < 0) handles.push(it.handle); });
    var p = { product: handles.join(','), items: added.length, value: cents / 100, currency: 'USD' };
    var k = btn.getAttribute('data-tg-ev-k'), v = btn.getAttribute('data-tg-ev-v');
    if (k && v) p[k] = v;
    /* v33: data-tg-ev-x="slot=1;source=band" adds more params (GA4 only), as read at click time. */
    (evx || '').split(';').forEach(function (kv) { var x = kv.split('='); if (x[0] && x[1]) p[x[0]] = x[1]; });
    if (window.gtag) gtag('event', ev, p);
    if (window.clarity) {
      clarity('event', ev);
      if (k && v) clarity('set', ev.replace(/_add_to_cart$/, '') + '_' + k, v);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tg-add], .tgp-body a[href*="/cart/"]');
    if (!btn || btn.disabled || btn.dataset.tgBusy) return;
    var items, perma = btn.tagName === 'A' ? (btn.getAttribute('href') || '').match(PERMA) : null;
    if (btn.tagName === 'A') {
      if (!perma) return;
      e.preventDefault();
      items = perma[1].split(',').map(function (p) { var x = p.split(':'); return { id: Number(x[0]), quantity: Number(x[1]) }; });
    } else {
      /* v38: an entry may carry a quantity, "variantId:qty" (snippets/tg-article-band reads guide.pack_qty); a bare id adds 1. */
      items = btn.getAttribute('data-tg-add').split(',').map(function (p) { var x = p.split(':'); return { id: Number(x[0]), quantity: Math.max(1, parseInt(x[1], 10) || 1) }; });
    }
    var box = btn.closest('[data-tg-msg-box]');
    var msg = box && box.querySelector('[data-tg-msg]');
    var evx = btn.getAttribute('data-tg-ev-x');
    btn.disabled = true; btn.dataset.tgBusy = '1';
    /* v33 (guide-impulse spec §3): buttons with data-tg-states say "Adding…", then "Added ✓" for 2 s. */
    var lab = btn.hasAttribute('data-tg-states') && btn.querySelector('[data-tg-label]');
    var was = lab && lab.textContent;
    if (lab) lab.textContent = 'Adding…';
    if (msg && lab) msg.textContent = '';
    /* v34: a guide add tags what it adds with the guide so the drawer's next-item card (snippets/tg-cart-extras) can suggest
       from this guide. v36 (live v34 sweep): the tag is a hidden line property, not a cart attribute, so it leaves with those
       lines; a cart attribute outlived an emptied cart and steered "One more for the lot" after later non-guide adds. */
    var gh = btn.getAttribute('data-tg-guide');
    if (gh) items.forEach(function (it) { it.properties = { _tg_guide: gh }; });
    Promise.resolve().then(function () {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer-section' })
      });
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (data) {
        track(btn, data.items || [], evx);
        var html = data.sections && data.sections['cart-drawer-section'];
        var cur = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (html && cur) {
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
          if (next) cur.replaceWith(next);
        }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (window.tgGiftCount) window.tgGiftCount(cart);
        if (icon && icon.renderCartBubble) icon.renderCartBubble(cart.item_count);
        if (msg && btn.dataset.tgDone) msg.textContent = btn.dataset.tgDone;
        btn.disabled = false; delete btn.dataset.tgBusy;
        if (lab) {
          lab.textContent = 'Added ✓'; btn.classList.add('is-added');
          setTimeout(function () { lab.textContent = was; btn.classList.remove('is-added'); }, 2000);
        }
        document.dispatchEvent(new CustomEvent('tg:cart', { detail: cart }));
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
        /* v33: from a guide, the drawer opens on the page; focus goes to its heading and comes back to the tapped
           button when it closes (Esc or the close button). guide_drawer_open fires once per open. */
        var g = btn.getAttribute('data-tg-guide');
        if (g) {
          var dlg = document.querySelector('#cart-drawer dialog, cart-drawer-component dialog');
          setTimeout(function () {
            var h = dlg && dlg.querySelector('h2, [id*="heading"]');
            if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
          }, 350);
          if (dlg) dlg.addEventListener('close', function () { if (document.body.contains(btn)) btn.focus(); }, { once: true });
          if (window.gtag) gtag('event', 'guide_drawer_open', { guide: g });
          if (window.clarity) clarity('event', 'guide_drawer_open');
        }
      })
      .catch(function () {
        btn.disabled = false; delete btn.dataset.tgBusy;
        if (lab) lab.textContent = was;
        if (perma) { window.location.href = btn.href; return; }
        if (msg) msg.textContent = btn.dataset.tgFail || "That didn't work. Open the product to add it.";
      });
  });
})();
